export function opposite(value: boolean): boolean {
  return !value
}
